import { Link } from "react-router-dom";
import s from "./guide.module.css";

function List({ title, items, id, suffix }) {
  if (!items?.length) return null;
  return (
    <>
      <h3>{title}</h3>
      <ul data-testid={`student-other-${id}`}>
        {items.map((r) => <li key={r.guide}><Link to={`${r.href}${suffix || ""}`} data-testid={`student-other-${id}-${r.guide}`}>{r.label}</Link></li>)}
      </ul>
    </>
  );
}

// Movement between subject guides (distinct from the section pager): published guides only, family first.
export function OtherGuides({ seo, suffix = "" }) {
  return (
    <nav className={s.related} aria-label="Other subject guides" data-testid="student-other-guides">
      <List title="In the same subject family" items={seo.related} id="family" suffix={suffix} />
      <List title="Explore another subject" items={seo.explore} id="explore" suffix={suffix} />
      <p><Link to={`${seo.directory || "/subjects"}${suffix}`} data-testid="student-other-directory">Browse all subject guides →</Link></p>
    </nav>
  );
}
